import React from 'react';
import { CheckIcon } from 'lucide-react';
export function FinancingSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-83">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84">
        <h2 className="text-3xl md:text-4xl font-bold text-navy mb-12 text-center" data-id="element-85">
          Machine Tool Financing Options
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-86">
          {/* U.S. Bank */}
          <div className="bg-gray-50 rounded-lg p-8 border-2 border-gray-200" data-id="element-87">
            <div className="w-full h-20 bg-gray-300 rounded-md mb-6 flex items-center justify-center" data-id="element-88">
              <span className="text-gray-600 font-semibold" data-id="element-89">
                U.S. Bank Logo
              </span>
            </div>

            <h3 className="text-2xl font-bold text-navy mb-6" data-id="element-90">
              U.S. Bank Financing
            </h3>

            <ul className="space-y-3" data-id="element-91">
              <li className="flex items-start" data-id="element-92">
                <CheckIcon className="w-5 h-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-93" />
                <span className="text-gray-700" data-id="element-94">100% Financing</span>
              </li>
              <li className="flex items-start" data-id="element-95">
                <CheckIcon className="w-5 h-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-96" />
                <span className="text-gray-700" data-id="element-97">
                  Competitive Rates Flexible Payments
                </span>
              </li>
              <li className="flex items-start" data-id="element-98">
                <CheckIcon className="w-5 h-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-99" />
                <span className="text-gray-700" data-id="element-100">Quick and Easy Process</span>
              </li>
              <li className="flex items-start" data-id="element-101">
                <CheckIcon className="w-5 h-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-102" />
                <span className="text-gray-700" data-id="element-103">
                  Convenient one-page application up to $500,000
                </span>
              </li>
            </ul>
          </div>

          {/* Banterra */}
          <div className="bg-gray-50 rounded-lg p-8 border-2 border-gray-200" data-id="element-104">
            <div className="w-full h-20 bg-gray-300 rounded-md mb-6 flex items-center justify-center" data-id="element-105">
              <span className="text-gray-600 font-semibold" data-id="element-106">Banterra Logo</span>
            </div>

            <h3 className="text-2xl font-bold text-navy mb-6" data-id="element-107">
              Banterra Machine Tool Finance
            </h3>

            <ul className="space-y-3 mb-6" data-id="element-108">
              <li className="flex items-start" data-id="element-109">
                <CheckIcon className="w-5 h-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-110" />
                <span className="text-gray-700" data-id="element-111">
                  Fixed, simple interest rate loans (no leases)
                </span>
              </li>
              <li className="flex items-start" data-id="element-112">
                <CheckIcon className="w-5 h-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-113" />
                <span className="text-gray-700" data-id="element-114">
                  Ability to make additional payments to principal at any time
                  (saves interest)
                </span>
              </li>
              <li className="flex items-start" data-id="element-115">
                <CheckIcon className="w-5 h-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-116" />
                <span className="text-gray-700" data-id="element-117">
                  Ability to pay off WITHOUT penalty at any time
                </span>
              </li>
            </ul>

            <p className="text-sm text-gray-600" data-id="element-118">www.banterramachinetool.com</p>
          </div>
        </div>
      </div>
    </section>;
}